/* Solfuerza Black Friday 2026 – Countdown + Slide-in-Logik */
(function(){
  if (window.__sfBfCountdown) return; window.__sfBfCountdown = true;
  function pad(n){ return (n<10?'0':'')+n; }
  function tick(){
    document.querySelectorAll('[data-bf-countdown]').forEach(function(el){
      var end = parseInt(el.getAttribute('data-bf-countdown'),10)*1000;
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff/86400000), h = Math.floor(diff%86400000/3600000), m = Math.floor(diff%3600000/60000), s = Math.floor(diff%60000/1000);
      var q = function(a){ return el.querySelector('[data-'+a+']'); };
      if (q('d')) q('d').textContent = pad(d);
      if (q('h')) q('h').textContent = pad(h);
      if (q('m')) q('m').textContent = pad(m);
      if (q('s')) q('s').textContent = pad(s);
    });
  }
  tick(); setInterval(tick, 1000);
  /* Auf Seiten mit eigenem Deal-Alarm-Formular (Startseite, Black-Friday-Seite) kein Slide-in, nur Floating-Button */
  if (document.querySelector('.bfalarm--hero')) {
    var sl = document.querySelector('[data-bfslide]'); if (sl) sl.remove();
    var fb = document.querySelector('[data-bffab]'); if (fb) fb.hidden = false;
  }
})();